enum RoutesPath {
  // Common routes
  AddPayment = "/add-payment/:subscriptionId",
  Dashboard = "/dashboard",
  Properties = "/properties",
  PropertyPreview = "/properties/:id/preview",
  PropertyPreviewAsClient = "/properties/:id/preview-as-client/:brokerId",
  Portfolios = "/portfolios",
  PortfolioDetails = "/portfolios/:id",
  UnavailablePortfolioPage = "/unavailable-portfolio-page",
  Messages = "/messages",
  Profile = "/profile",
  SignIn = "/auth/sign-in",
  SignUp = "/auth/sign-up",
  CompleteSignUpCodeConfirmation = "/auth/complete-sign-up",
  CompleteSignUpSSO = "/auth/complete-sign-up-sso",
  CompleteSignUpPickSubscription = "/auth/pick-subscription",
  CompleteSignUpAddPayment = "/auth/add-payment/:subscriptionId",
  CompleteSignUpAddAdditionalInfo = "/auth/add-additional-info",
  StripeCheckoutResult = "/auth/stripe-checkout-result",
  ForgotPassword = "/auth/forgot-password",
  ResetPassword = "/auth/resetPassword",
  // IDX Paths
  Exchange = "/exchange",
  ExchangeDetails = "/exchange/:idxFeedId",
  ExchangeEmbeddedPortfolio = "/exchange/embedded/:idxFeedId/portfolio/:portfolioId",
  ExchangeEmbeddedProperty = "/exchange/embedded/:idxFeedId/property/:propertyId",
  ExchangeEmbeddedSearch = "/exchange/embedded/:idxFeedId/search-bar",
  ExchangeUnauthorized = "/exchange/error/unauthorized",
  // public urls
  PortfolioPreview = "/portfolio-folder/:brokerId/:brokerName/:portfolioFolderName",
  PropertyInPortfolioPreview = "/portfolio-folder-item/:brokerId/:brokerName/:portfolioFolderName/:portfolioName",
  PortfolioPropertyPreview = "/portfolio-item/:brokerId/:brokerName/:portfolioName",
  Tracking = "/tracking",
  TermConditions = "/term-conditions",
  PrivacyPolicy = "/privacy-policy",
  SSOCallback = "/auth/sso-callback",
}

export { RoutesPath };
